// extracted by mini-css-extract-plugin
export default {"container":"IconText_container__0TNdI","icon":"IconText_icon__qO4Q2","text":"IconText_text__i77tk"};